<ng-template cxOutlet="cx-storefront">
  <ng-template cxOutlet="cx-header">
    @if (!hideHeader && !isModal) {
      <dcp-header></dcp-header>
    }
    @if (!hideHeader && !isModal) {
      <cx-page-layout section="navigation"></cx-page-layout>
    }
    <dcp-global-message></dcp-global-message>
    <dcp-toasts></dcp-toasts>
  </ng-template>
  @if (addCaptchaContainer) {
    <div [id]="reCaptchaContainerId"></div>
  }
  <router-outlet></router-outlet>

  @if (!isModal) {
    <dcp-udex-footer></dcp-udex-footer>
  }

  <dcp-chat-advisor [visible]="showChatAdvisor$ | async" [context]="chatAdvisorContext$ | async"/>
</ng-template>
